import React, {useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Button from 'src/components/Button';
import { Popup } from 'src/components/Popup';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { getPreSignedUrl } from 'src/utils/helpers';
import Styled from 'src/components/JobMobileDataTab/MobileDataPhotoDownload.styles'

const _ = require('lodash');

const MobileDataPhotoDownload = (props) => {

  const { checklistQuestionsData, photoRecordsData} = props;
  const { t } = useTranslation();
  const [showPreview, setShowPreview] = useState(false);

  let allPrimary = [];
  allPrimary = photoRecordsData.filter(record => record.isPrimary);

  let allNonPrimary = [];
  allNonPrimary = photoRecordsData.filter(record => record.isPrimary === false);

  const onDownloadClick = (event) => {
    event.preventDefault();
    setShowPreview(true);
  };

  const getAllPhotoRecordsWithBlob = async () => {
    const result = await Promise.all(
      allPrimary.map(
        async (attachment) => {
          const attachmentId = (attachment.showAltered
            ? attachment.alteredAttachmentId
            : attachment.attachmentId) || null;
          if (!attachmentId) {
            return null;
          }
          try {
            const url = await getPreSignedUrl(attachmentId, attachment.filename);
            const response = await fetch(url);
            const blob = await response.blob();
            return { ...attachment, blob };
          } catch (e) {
            console.error(e);
          }

          return null;
        }
      ));

    return result.filter(c => c !== null);
  }

  const getResult = (question, checklistId) => {
    return (
      checklistQuestionsData.find(
        v => v.questionId === question && v.checklistId === checklistId
      )?.questionNumber || ''
    );
  };

  const checkInvalidChar = (tagStr) => {
    /* eslint-disable no-useless-escape */
    return tagStr.replace(/[\/\\^$*+?()|[\]{}]/g, ' ');
  }

  const onClickDownloadAllPhotos = async (e) => {
    e.preventDefault();
    const dataWithBlob = await getAllPhotoRecordsWithBlob();

    const zip = new JSZip();
    const folder = zip.folder('collection');
    const filenameCountMap = new Map();
    dataWithBlob.forEach((d, index) => {
      const primaryRecordQuestionNumber = getResult(d.questionId, d.checklistId);
      const relatedNonPrimary = allNonPrimary.filter(c => c.filename === d.filename);
      const nonPrimaryRecordQuestionNumbersArray = relatedNonPrimary.map(recordsNonPrimary => {
          const questionNumber = getResult(recordsNonPrimary.questionId,recordsNonPrimary.checklistId);
          return questionNumber;
      });
      const questionId = _.uniq([primaryRecordQuestionNumber, ...nonPrimaryRecordQuestionNumbersArray])
                                .filter(questionNumber => Boolean(questionNumber))
                                .join(', ');

      const tagListData = [];
      for (let i = 0; i < d.tags.length; i += 1) {
        tagListData.push(d.tags[i].name.trim());
      };
      const urlSplit = d.filename.split('?');
      const imageName = urlSplit[0].split('/');
      const imageNameKey = imageName.length - 1;
      const tagListName = questionId.length > 0 ? ` - ${tagListData}` : `${tagListData}`;

      /* eslint-disable no-useless-escape */
      const imageRecordIdrecord = questionId.length > 0 ? ` - ${imageName[imageNameKey]}` : `${imageName[imageNameKey]}`;
      if(imageRecordIdrecord !== undefined){
        const fileExtension = imageRecordIdrecord.split('.').pop();
          const fullFileName = tagListData.length === 0 ? `${ checkInvalidChar(questionId + imageRecordIdrecord)}` : `${checkInvalidChar(questionId + tagListName)}`;
          let finalFileName = `${fullFileName}.${fileExtension}`;
          if(filenameCountMap.has(finalFileName)){
            const currentCount = filenameCountMap.get(finalFileName);
            // order of below two steps matter we are changing finalFilename value in last statement
            filenameCountMap.set(finalFileName, currentCount+1);
            finalFileName = `${fullFileName}(${currentCount}).${fileExtension}`
          }else{
             filenameCountMap.set(finalFileName,1)
          }

          folder.file(finalFileName, d.blob);
      }
    });

    const content = await folder.generateAsync({ type: 'blob' });
    saveAs(content, "AllPhotos.zip");
  };

  const onClickDownloadFindingPhotos = async (e) => {
    e.preventDefault();

    const dataWithBlob = await getAllPhotoRecordsWithBlob();

    const zip = new JSZip();
    const folder = zip.folder('images');
    const filenameCountMap = new Map();
    dataWithBlob.forEach((d, index) => {

      const primaryRecordQuestionNumber = getResult(d.questionId, d.checklistId);
      const relatedNonPrimary = allNonPrimary.filter(c => c.filename === d.filename);
      const nonPrimaryRecordQuestionNumbersArray = relatedNonPrimary.map(recordsNonPrimary => {
          const questionNumber = getResult(recordsNonPrimary.questionId,recordsNonPrimary.checklistId);
          return questionNumber;
      });
      const questionId = _.uniq([primaryRecordQuestionNumber, ...nonPrimaryRecordQuestionNumbersArray])
                                .filter(questionNumber => Boolean(questionNumber))
                                .join(', ');

      if(d !== undefined && d.showFindings) {
        const tagListData = [];
        for (let i = 0; i < d.tags.length; i += 1) {
          tagListData.push(d.tags[i].name.trim());
        }

        const urlSplit = d.filename.split('?');
        const imageName = urlSplit[0].split('/');
        const imageNameKey = imageName.length - 1;
        const tagListName = questionId.length > 0 ? ` - ${tagListData}` : `${tagListData}`;

        /* eslint-disable no-useless-escape */
        const imageRecordIdrecord = questionId.length > 0 ? `- ${imageName[imageNameKey]}` : `${imageName[imageNameKey]}`;
        if(imageRecordIdrecord !== undefined){
          const fileExtension = imageRecordIdrecord.split('.').pop();
          const fullFileName = tagListData.length === 0 ? `${ checkInvalidChar(questionId + imageRecordIdrecord)}` : `${checkInvalidChar(questionId + tagListName)}`;

          let finalFileName = `${fullFileName}.${fileExtension}`;
          if(filenameCountMap.has(finalFileName)){
            const currentCount = filenameCountMap.get(finalFileName);
            // order of below two steps matter we are changing finalFilename value in last statement
            filenameCountMap.set(finalFileName, currentCount+1);
            finalFileName = `${fullFileName}(${currentCount}).${fileExtension}`
          }else{
             filenameCountMap.set(finalFileName,1)
          }
          folder.file(finalFileName, d.blob);
        }
      }
    });
    const content = await folder.generateAsync({ type: 'blob' });
    saveAs(content, "AllFindingsPhotos.zip");
  };

  return (
    <>
      {showPreview && (
        <Popup level={0} onClose={() => setShowPreview(false)}>
          <Button onClick={onClickDownloadAllPhotos}>{t('DOWNLOAD_ALL_PHOTOS_BTN_TXT')}</Button>
          <Button onClick={onClickDownloadFindingPhotos}>{t('DOWNLOAD_FINDINGS_PHOTOS_BTN_TXT')}</Button>
        </Popup>
      )}

      {
          <>
            &nbsp;<Button
            onClick={onDownloadClick}
            disabled={!photoRecordsData?.length}
            className={Styled.Classes['btn-save-and-apply']}
            >
              {t('DOWNLOAD_PHOTOS_BTN_TXT')}
            </Button>
          </>
      }
    </>
  );
};

MobileDataPhotoDownload.propTypes = {
  photoRecordsData: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  checklistQuestionsData: PropTypes.array.isRequired,
};

export default React.memo(MobileDataPhotoDownload);
